/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createStyles, WithStyles } from '@material-ui/core';
import { color } from '../../../../lib/Theme/Theme';
import { SIZES } from '../../../../lib/Constants';
import { globalStyles } from '../../../../lib/Theme/GlobalStyles';

export const styles = createStyles({
  secondaryTile: globalStyles.secondaryTile as any,
  titleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: color.secondary,
    alignItems: 'center',
    padding: '25px 30px',
  },
  title: {
    color: color.sortedNavy,
    fontSize: 28,
    marginBottom: '10px',
  },
  subtitle: {
    fontWeight: 'lighter',
    opacity: 0.87,
  },

  contentContainer: {
    padding: '30px',
    backgroundColor: color.light,
  },
  inputContainerStyle: {
    width: '100%',
    paddingBottom: '8px',
  },
  inputStyle: {
    paddingTop: '5px',
    paddingBottom: '10px',
    color: color.secondary600,
  },
  errorText: {
    color: color.warning,
    marginTop: '15px',
    fontWeight: 300,
  },
  inputRow: {
    display: 'grid',
    gridAutoFlow: 'column',
    columnGap: '30px',
    [`@media (max-width: ${SIZES.md}px)`]: {
      gridAutoFlow: 'row',
    },
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '30px',
    [`@media (max-width: ${SIZES.md}px)`]: {
      flexDirection: 'column-reverse',
      width: '100%',
    },
  },
  signupButton: {
    backgroundColor: color.teal,
    fontSize: 16,
    fontWeight: 300,
    border: 'none',
    borderRadius: '6px',
    padding: '15px',
    width: '180px',
    color: color.light,
    cursor: 'pointer',
    textAlign: 'center',
    [`@media (max-width: ${SIZES.md}px)`]: {
      flex: 1,
      marginTop: '15px',
      width: '100%',
    },
  },
  secondaryActionContainer: {
    display: 'flex',
    justifyContent: 'center',
    [`@media (max-width: ${SIZES.md}px)`]: {
      marginTop: '30px',
    },
  },
  secondaryActionText: {
    fontWeight: 100,
  },
  secondaryAction: {
    marginLeft: '8px',
    color: color.sortedNavy,
    cursor: 'pointer',
  },
});

export interface SignupFormStyles extends WithStyles<typeof styles> {}
